<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
    class="area-selecter"
  >
    <template slot="select-header">
      {{ letter.region }}
    </template>
    <template slot="select-content">
      <p
        tagName="p"
        type="activeListItem"
        class="current-area select-items active"
      >
        {{ curLocation }}
      </p>
      <List class="area-select-container j-area-select-container">
        <ListItem
          type="locationItem"
          v-for="(area, index) in locations"
          :data-code="area.value"
          @click="selectLocation(area)"
          class="areas-lst select-items"
          pointClass="j-select-area"
          :pointValue="area.value"
          :key="index"
          v-show="area.name !== curLocation"
        >
          {{ area.name }}
        </ListItem>
      </List>
    </template>
  </SelectContianer>
</template>
<script>
import selectContainer from '@mixins/officialStore/selectContainer';
import {
  getLocationNameByVal,
  getCurLocation
} from '@store/officialStore/storager';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV1';
export const HIDE_AREA_SELECTOR = 'hideAreaSelector';
export default {
  data() {
    // let curLocationsVal = getCurLocation();
    return {
      curLocation: getLocationNameByVal(this.curLocationsVal)
    };
  },
  props: ['locations', 'curLocationsVal'],
  methods: {
    selectLocation(area) {
      this.curLocation = area.name;
      clickButton({
        btnName: 'select_regions',
        locationKey: locationType.paytypeSection
      });
      this.$emit(HIDE_AREA_SELECTOR, area);
    }
  },
  mixins: [selectContainer]
};
</script>

<style lang="scss" scoped>
.area-selecter {
  z-index: 1002;
}
.areas-lst,
.current-area {
  display: flex;
  width: 100%;
  min-height: 80px;
  line-height: 80px;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  margin-bottom: 10px;
  position: relative;
  transition: all 0.2s ease;
  font-size: 28px;
  color: #333;
  border: 1px solid #333;
}
.current-area.active {
  color: #b20000;
  border: 1px solid #b20000;
}
</style>
